export default __webpack_public_path__ + "static/media/sub_page_about_en.a85e2342.svg";